import api_config from "../../../api/config/_user";
import api_param from "../../../api/comptabilite/_configs"

export default {
    getCouponAuthorizedUsers() {
        return new Promise((resolve, reject) => {
            api_config.getCouponAuthorizedUsers().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setResetPwdCode(data) {
        return new Promise((resolve, reject) => {
            api_config.setResetPwdCode(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    changePassword(data) {
        return new Promise((resolve, reject) => {
            api_config.changePassword(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    selectListeCaissieres(data) {
        return new Promise((resolve, reject) => {
            api_config.selectListeCaissieres(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveCustomExclusion(data) {
        return new Promise((resolve, reject) => {
            api_param.saveCustomExclusion(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    selectCustomExclusions() {
        return new Promise((resolve, reject) => {
            api_param.selectCustomExclusions().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}